import BaseService from "@root/core/class/BaseService";

class buskService extends BaseService {
  public getTotalInfo = () => {
    return this.get("/totalInfo");
  };
  public getSignupRequest = () => {
    return this.get("/signupRequest");
  };
  public getAmendmentRequest = () => {
    return this.get("/amendmentRequest");
  };
}

export default new buskService("/api/v1/admin", true);
